let ON_CHANGE_DEBOUNCE_TIMER = 300,
    PUB_SUB_EVENTS = {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        variantChange: "variant-change",
        cartError: "cart-error",
    },
    subscribers = {};
function subscribe(e, t) {
    return (
        void 0 === subscribers[e] && (subscribers[e] = []),
        (subscribers[e] = [...subscribers[e], t]),
        function () {
            subscribers[e] = subscribers[e].filter((e) => e !== t);
        }
    );
}
function publish(e, t) {
    subscribers[e] &&
        subscribers[e].forEach((e) => {
            e(t);
        });
}
let activeOptions = {};
function debounce(e, t) {
    let i;
    return (...n) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, n), t));
    };
}
function getStyleProperty(e, t) {
    return window.getComputedStyle(e).getPropertyValue(t);
}
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (let n = 0, s = e.options.length; n < s; n++) {
            var i = e.options[n];
            if (t == i.value || t == i.innerHTML) return (e.selectedIndex = n);
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i,
            n = (t = t || {}).method || "post",
            s = t.parameters || {},
            o = document.createElement("form");
        for (i in (o.setAttribute("method", n), o.setAttribute("action", e), s)) {
            var r = document.createElement("input");
            r.setAttribute("type", "hidden"),
                r.setAttribute("name", i),
                r.setAttribute("value", s[i]),
                o.appendChild(r);
        }
        document.body.appendChild(o), o.submit(), document.body.removeChild(o);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry() {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince() {
            var e = this.provinceEl.getAttribute("data-default");
            e && 0 < this.provinceEl.options.length && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler(e) {
            var t = this.countryEl.options[this.countryEl.selectedIndex],
                i = t.getAttribute("data-provinces"),
                n = JSON.parse(i);
            if ((this.clearOptions(this.provinceEl), n && 0 == n.length)) this.provinceContainer.style.display = "none";
            else {
                for (let e = 0; e < n.length; e++)
                    ((t = document.createElement("option")).value = n[e][0]),
                        (t.innerHTML = n[e][1]),
                        this.provinceEl.appendChild(t);
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions(e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions(e, t) {
            let i = 0;
            for (t.length; i < t.length; i++) {
                var n = document.createElement("option");
                (n.value = t[i]), (n.innerHTML = t[i]), e.appendChild(n);
            }
        },
    });
class QuantityCounter extends HTMLElement {
    constructor() {
        super(), (this.changeEvent = new Event("change", { bubbles: !0 }));
    }
    connectedCallback() {
        this.counterEl = this.querySelector(".js-counter-quantity");
        this.increaseBtn = this.querySelector(".js-counter-increase");
        this.decreaseBtn = this.querySelector(".js-counter-decrease");
        this.min = this.counterEl.min !== "" ? parseInt(this.counterEl.min) : 1;
        this.max = parseInt(this.counterEl.max) || 999;
        this.step = parseInt(this.counterEl.step) || 1;
        this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
        this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
    }
    onIncrease() {
        const currentValue = parseInt(this.counterEl.value);
        const newValue = currentValue + this.step;
        if (newValue <= this.max) {
            this.updateValue(newValue);
        }
    }
    onDecrease() {
        const currentValue = parseInt(this.counterEl.value);
        const effectiveMin = this.dataset.cart ? 0 : this.min;
        const newValue = currentValue - this.step;
        if (newValue >= effectiveMin) {
            this.updateValue(newValue);
        } else if (this.dataset.cart && currentValue > 0) {
            this.updateValue(0);
        }
    }
    updateValue(e) {
        (this.counterEl.value = e), this.counterEl.dispatchEvent(this.changeEvent);
    }
}
function getFocusableElements(e) {
    return Array.from(
        e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}
function toggleTabindex(e) {
    e.forEach((e) => {
        var t = e.getAttribute("tabindex");
        e.setAttribute("tabindex", "0" === t ? "-1" : "0");
    });
}
function setTabindex(e, t) {
    e.forEach((e) => {
        e.setAttribute("tabindex", t);
    });
}
function addEventListeners(e, t, i) {
    t.forEach((t) => e.addEventListener(t, i));
}
window.customElements.define("quantity-counter", QuantityCounter),
    document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
        e.setAttribute("role", "button"),
            e.setAttribute("aria-expanded", e.parentNode.hasAttribute("open")),
            e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
            e.addEventListener("click", (e) => {
                e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
            }),
            e.closest("header-drawer, menu-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
    });
let trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e);
    let n = i[0],
        s = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== s && t.target !== n) ||
                document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() &&
                (t.target !== s || t.shiftKey || (t.preventDefault(), n.focus()), t.target === e || t.target === n) &&
                t.shiftKey &&
                (t.preventDefault(), s.focus());
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus(),
        "INPUT" === t.tagName &&
            ["search", "text", "email", "url"].includes(t.type) &&
            t.value &&
            t.setSelectionRange(0, t.value.length);
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
        document.removeEventListener("focusout", trapFocusHandlers.focusout),
        document.removeEventListener("keydown", trapFocusHandlers.keydown),
        e && e.focus();
}
function onKeyUpEscape(e) {
    var t;
    "ESCAPE" === e.code.toUpperCase() &&
        (e = e.target.closest("details[open]")) &&
        ((t = e.querySelector("summary")), e.removeAttribute("open"), t.setAttribute("aria-expanded", !1), t.focus());
}
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }
    async connectedCallback() {
        new IntersectionObserver(
            ((e, t) => {
                e[0].isIntersecting &&
                    (t.unobserve(this),
                    fetch(this.dataset.url)
                        .then((e) => e.text())
                        .then((e) => {
                            var t = document.createElement("div");
                            (e = ((t.innerHTML = e), t.querySelector("product-recommendations"))) &&
                                e.innerHTML.trim().length &&
                                (this.innerHTML = e.innerHTML),
                                t.querySelector(".grid__item") && this.classList.add("product-recommendations--loaded");
                        })
                        .catch((e) => {
                            console.error(e);
                        }));
            }).bind(this),
            { rootMargin: "0px 0px 400px 0px" }
        ).observe(this);
    }
}
customElements.define("product-recommendations", ProductRecommendations);
class DrawerNavSection extends HTMLElement {
    constructor() {
        super(),
            (this.headerParentLinkClass = "wt-header__nav-teaser__link--parent"),
            (this.pageOverlayClass = "menu-drawer-overlay"),
            (this.triggerQuery = [
                ".wt-header__menu-trigger",
                "." + this.headerParentLinkClass,
                ".wt-drawer__close",
                "." + this.pageOverlayClass,
            ].join(", ")),
            (this.triggers = () => document.querySelectorAll(this.triggerQuery)),
            (this.getHeaderHeight = () => getStyleProperty(document.querySelector(".wt-header"), "height")),
            (this.headerMenu = document.querySelector(".wt-header--v3")),
            (this.menuToggleButton = document.querySelector(".wt-header__menu-trigger")),
            (this.closeButton = this.querySelector(".wt-drawer__close")),
            (this.isOpen = !1),
            (this.triggerElement = null),
            (this.isAlwaysMobile = () => document.body.classList.contains("mobile-nav")),
            (this.desktopBreakpoint = 1200),
            (this.isDesktop = () => window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).matches);
    }
    connectedCallback() {
        this.init();
    }
    openMobileSubmenu(e) {
        var t = document.querySelectorAll(".wt-page-nav-mega__link--parent");
        let i = "submenu-opened";
        t.forEach((t) => {
            t.classList.remove(i),
                t.attributes?.href?.value === e &&
                    (t.classList.add(i),
                    setTabindex((t = t.nextElementSibling.querySelectorAll('a[data-menu-level="2"]')), "0"));
        });
    }
    handleTabindex() {
        var e = this.querySelectorAll('a[data-menu-level="1"]');
        this.isAlwaysMobile() || setTabindex(e, this.isDesktop() ? "0" : "-1");
    }
    updateAriaStateForTriggers() {
        document.querySelectorAll("[aria-controls='wt-drawer-nav']").forEach((e) => {
            var t = this.isOpen;
            e.setAttribute("aria-expanded", t);
        });
    }
    temporaryHideFocusVisible() {
        document.body.classList.add("no-focus-visible");
    }
    openMenu(e) {
        (this.isOpen = !0),
            (this.triggerElement = e.currentTarget),
            this.closeButton.setAttribute("tabindex", "0"),
            this.closeButton.focus(),
            this.temporaryHideFocusVisible();
    }
    closeSubmenus() {
        this.querySelectorAll(".submenu-opened").forEach((e) => {
            e.classList.remove("submenu-opened");
            var t =
                (setTabindex((t = e.nextElementSibling.querySelectorAll('a[data-menu-level="2"]')), "-1"),
                e.nextElementSibling.querySelectorAll('a[data-menu-level="3"]'));
            setTabindex(t, "-1");
        });
    }
    closeMenu() {
        (this.isOpen = !1),
            this.triggerElement.focus(),
            (this.triggerElement = null),
            this.closeButton.setAttribute("tabindex", "-1"),
            this.closeSubmenus(),
            this.temporaryHideFocusVisible();
    }
    toggleMenu(e) {
        e.preventDefault(), this.isOpen ? this.closeMenu(e) : this.openMenu(e), this.updateAriaStateForTriggers();
        var t = this.querySelectorAll('a[data-menu-level="1"]'),
            i = this.querySelectorAll("a.wt-page-nav-mega__aside-list__link");
        toggleTabindex(t),
            toggleTabindex(i),
            this.toggleMenuButtonAttr(),
            (t = document.querySelectorAll("body.nav-drawer-big").length ? 0 : this.getHeaderHeight()),
            (i = document.querySelector(".wt-drawer__content"));
        e.currentTarget.classList.contains("wt-header__nav-teaser__link--parent") &&
            this.openMobileSubmenu(e.currentTarget.attributes?.href?.value),
            document.body.classList.toggle("menu-open"),
            document.body.classList.toggle("menu-drawer-overlay-on"),
            i.style.setProperty("padding-top", t);
    }
    toggleMenuButtonAttr() {
        var e = "true" === this.menuToggleButton.dataset.open ? "false" : "true";
        this.menuToggleButton.dataset.open = e;
    }
    toggleThirdOptionMenu() {
        var e,
            t = document.querySelector(".wt-header__icon.wt-header__menu-trigger.wt-icon");
        this.headerMenu && ((e = "true" === t.dataset.open ? "false" : "true"), (t.dataset.open = e));
    }
    getFocusableElements() {
        var e = () =>
            Array.from(this.querySelectorAll("button, [href], input, select, [tabindex]")).filter(
                (e) => !e.hasAttribute("disabled") && 0 <= e.tabIndex
            );
        return { focusableElements: e, first: e()[0], last: e()[e().length - 1] };
    }
    init() {
        var e;
        document.querySelector("." + this.pageOverlayClass) ||
            ((e = document.createElement("div")).classList.add(this.pageOverlayClass), document.body.appendChild(e)),
            this.handleTabindex(),
            window.addEventListener("resize", this.handleTabindex.bind(this)),
            this.addEventListener("keydown", (e) => {
                var t = "Tab" === e.key || 9 === e.keyCode || "Tab" === e.code,
                    { first: i, last: n } = this.getFocusableElements();
                ("Escape" !== e.key && 27 !== e.keyCode && "Escape" !== e.code) || (this.isOpen && this.toggleMenu(e)),
                    (this.isDesktop() && !this.isAlwaysMobile()) ||
                        (t &&
                            (e.shiftKey && document.activeElement === i
                                ? (n.focus(), e.preventDefault())
                                : e.shiftKey || document.activeElement !== n || (i.focus(), e.preventDefault())));
            }),
            this.triggers().forEach((e) => {
                e.addEventListener("click", (e) => {
                    this.toggleMenu(e), this.toggleThirdOptionMenu();
                });
            });
    }
}
customElements.define("drawer-nav", DrawerNavSection);
class MegaMenuSection extends HTMLElement {
    constructor() {
        super(),
            (this.menuParentItems = this.querySelectorAll(".wt-page-nav-mega__item--parent")),
            (this.menuParentLinks = this.querySelectorAll(".wt-page-nav-mega__link--parent")),
            (this.menuSubmenuParentLinks = this.querySelectorAll(".wt-page-nav-mega__sublist__link--parent")),
            (this.classParentActiveMobile = "submenu-opened"),
            (this.classParentActiveDesk = "dropdown-opened"),
            (this.classBodyActiveDesk = "dropdown-open-desk"),
            (this.isAlwaysMobile = () => "true" === document.querySelector("page-header").dataset.alwaysMobileMenu),
            (this.desktopBreakpoint = 1200),
            (this.isDesktop = () => window.matchMedia(`(min-width: ${this.desktopBreakpoint}px)`).matches),
            (this.currentlyActiveSubmenu = null);
    }
    connectedCallback() {
        this.init();
    }
    toggleParentMob(e) {
        let { menuParentLinks: t, classParentActiveMobile: i } = this;
        toggleTabindex(e.nextElementSibling.querySelectorAll("[data-menu-level='2']")),
            t.forEach((t) => {
                var n, s;
                t !== e
                    ? (t.classList.remove(i),
                      (n = (s = t.nextElementSibling).querySelectorAll("[data-menu-level='2']")),
                      (s = s.querySelectorAll("[data-menu-level='3']")),
                      t.classList.remove(i),
                      setTabindex(n, "-1"),
                      setTabindex(s, "-1"))
                    : (e.classList.toggle(i),
                      e.classList.contains(i) ||
                          e.nextElementSibling.querySelectorAll(".submenu-opened").forEach((e) => {
                              e.classList.remove("submenu-opened"),
                                  setTabindex(
                                      (e = e.nextElementSibling.querySelectorAll('a[data-menu-level="3"]')),
                                      "-1"
                                  );
                          }));
            });
    }
    toggleSubmenuMob(e) {
        let { menuSubmenuParentLinks: t, classParentActiveMobile: i } = this;
        toggleTabindex(e.nextElementSibling.querySelectorAll("[data-menu-level='3']")),
            t.forEach((t) => {
                var n;
                t !== e
                    ? (t.classList.remove(i),
                      (n = t.nextElementSibling.querySelectorAll("[data-menu-level='3']")),
                      t.classList.remove(i),
                      setTabindex(n, "-1"))
                    : e.classList.toggle(i);
            });
    }
    hasClassMobileNav() {
        return document.body.classList.contains("mobile-nav");
    }
    isMobileMenu() {
        return !window.matchMedia("(min-width: 1200px)").matches || this.hasClassMobileNav();
    }
    initTabindex() {
        this.isDesktop() && !this.isAlwaysMobile() && setTabindex(this.querySelectorAll('a[data-menu-level="1"]'), "0");
    }
    init() {
        let {
                menuParentLinks: e,
                menuSubmenuParentLinks: t,
                menuParentItems: i,
                classBodyActiveDesk: n,
                classParentActiveDesk: s,
            } = this,
            o =
                (e.forEach((e) => {
                    e.addEventListener("click", (t) => {
                        this.isMobileMenu() && (t.preventDefault(), this.toggleParentMob(e));
                    });
                }),
                t.forEach((e) => {
                    e.addEventListener("click", (t) => {
                        this.isMobileMenu() && (t.preventDefault(), this.toggleSubmenuMob(e));
                    });
                }),
                this.initTabindex(),
                (e) => {
                    var t = e
                        .querySelector('a[data-menu-level="1"]')
                        .nextElementSibling.querySelectorAll('a[data-menu-level="2"],a[data-menu-level="3"]');
                    this.isDesktop() && !this.isAlwaysMobile() && setTabindex(t, e.classList.contains(s) ? "0" : "-1");
                }),
            r = "submenu--left";
        i.forEach((e, t) => {
            addEventListeners(e, ["mouseover", "focusin"], (t) => {
                document.body.classList.add(n), e.classList.add(s);
                var i = e.getBoundingClientRect().x;
                i = window.innerWidth / 2 < i;
                e.classList.toggle(r, i), o(e);
            }),
                addEventListeners(e, ["mouseout", "focusout"], (t) => {
                    document.body.classList.remove(n), e.classList.remove(s);
                    e.getBoundingClientRect().x;
                    window.innerWidth, e.classList.remove(r), o(e);
                });
        });
    }
}
customElements.define("mega-menu-section", MegaMenuSection);
class CollapsibleSection extends HTMLElement {
    constructor() {
        super(),
            this.extractOptionsFromURL(),
            (this.previousWidth = window.innerWidth),
            (this.selectorInteractiveElements = "button, [href], input, select, [tabindex]"),
            (this.triggerClass = ".wt-collapse__trigger"),
            (this.classActiveTrigger = "wt-collapse__trigger--active"),
            (this.openAttr = this.dataset.open),
            (this.accordionSet = this.dataset.accordionSet),
            (this.mobileOnly = this.hasAttribute("data-mobile-only")),
            (this.breakpoint = 900),
            (this.trigger = this.querySelector(this.triggerClass)),
            (this.content = this.querySelector(".wt-collapse__target")),
            (this.handleDelegatedEvent = this.handleDelegatedEvent.bind(this)),
            (this.handleResize = this.handleResize.bind(this));
    }
    static get observedAttributes() {
        return ["data-open"];
    }
    attributeChangedCallback(e, t, i) {
        "data-open" === e && t !== i && this.handleAriaAndTabindex();
    }
    connectedCallback() {
        this.initialize(),
            document.addEventListener("click", this.handleDelegatedEvent),
            this.mobileOnly && window.addEventListener("resize", this.handleResize);
    }
    disconnectedCallback() {
        document.removeEventListener("click", this.handleDelegatedEvent),
            this.mobileOnly && window.removeEventListener("resize", this.handleResize);
    }
    isOpen() {
        return "true" === this.dataset.open;
    }
    isMobileView() {
        return window.innerWidth < this.breakpoint;
    }
    getInteractiveElements(e) {
        return Array.from(e.querySelectorAll(this.selectorInteractiveElements)).filter(
            (e) => !e.hasAttribute("disabled")
        );
    }
    handleAriaAndTabindex() {
        this.isOpen()
            ? (this.trigger.setAttribute("aria-expanded", "true"),
              this.setTabindex(this.getInteractiveElements(this.content), "0"))
            : (this.trigger.setAttribute("aria-expanded", "false"),
              this.setTabindex(this.getInteractiveElements(this.content), "-1")),
            this.mobileOnly && !this.isMobileView()
                ? (this.setTabindex(this.getInteractiveElements(this.content), "0"),
                  this.trigger.setAttribute("tabindex", "-1"))
                : this.trigger.setAttribute("tabindex", "0");
    }
    setTabindex(e, t) {
        e.forEach((e) => e.setAttribute("tabindex", t));
    }
    extractOptionsFromURL() {
        var e = window.location.href?.match(/option\.([^&]+)/g);
        let t = {};
        e?.forEach((e) => {
            var [e, i] = e.split("="),
                i = decodeURIComponent(i).replace("+", " ");
            e = e.split(".")[1];
            t.hasOwnProperty(e) ? t[e].push(i) : (t[e] = [i]);
        }),
            (activeOptions = t);
    }
    toggleState() {
        var e = this.isOpen();
        (this.dataset.open = e ? "false" : "true"), this.trigger.classList.toggle(this.classActiveTrigger);
    }
    toggleAccordion() {
        var e = document.querySelectorAll(`collapsible-section[data-accordion-set="${this.accordionSet}"]`);
        this.isOpen()
            ? this.toggleState()
            : (e.forEach((e) => {
                  e !== this &&
                      ((e.dataset.open = "false"), (e = e.querySelector(this.triggerClass))) &&
                      e.classList.remove(this.classActiveTrigger);
              }),
              (this.dataset.open = "true"),
              this.trigger.classList.add(this.classActiveTrigger));
    }
    handleDelegatedEvent(e) {
        (e = e.target.closest(this.triggerClass)) &&
            this.contains(e) &&
            (this.accordionSet ? this.toggleAccordion() : this.toggleState());
    }
    handleResize() {
        var e = window.innerWidth;
        e !== this.previousWidth &&
            ((this.previousWidth = e), this.isMobileView() ? this.enableCollapsible() : this.disableCollapsible());
    }
    enableCollapsible() {
        "true" === this.openAttr
            ? ((this.dataset.open = "true"), this.trigger.classList.add(this.classActiveTrigger))
            : ((this.dataset.open = "false"), this.trigger.classList.remove(this.classActiveTrigger)),
            this.trigger.setAttribute("tabindex", "0"),
            this.handleAriaAndTabindex();
    }
    disableCollapsible() {
        (this.dataset.open = "true"),
            this.trigger.classList.remove(this.classActiveTrigger),
            this.trigger.setAttribute("aria-expanded", "false"),
            this.setTabindex(this.getInteractiveElements(this.content), "0"),
            this.trigger.setAttribute("tabindex", "-1");
    }
    initialize() {
        this.mobileOnly
            ? this.isMobileView()
                ? this.enableCollapsible()
                : this.disableCollapsible()
            : ("true" === this.openAttr && this.trigger.classList.add(this.classActiveTrigger),
              this.trigger.setAttribute("tabindex", "0"),
              this.handleAriaAndTabindex());
    }
}
customElements.define("collapsible-section", CollapsibleSection);
class JsLink extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.handleClickOrEnter = this.handleClickOrEnter.bind(this)),
            (this.handleMouseWheelClick = this.handleMouseWheelClick.bind(this)),
            (this.worksOnlyForMobile = Boolean(this.dataset.mobile)),
            this.initialize();
    }
    initialize() {
        this.addEventListener("click", this.handleClickOrEnter),
            this.addEventListener("mousedown", this.handleMouseWheelClick);
    }
    removeEventListeners() {
        this.removeEventListener("click", this.handleClickOrEnter),
            this.removeEventListener("mousedown", this.handleMouseWheelClick);
    }
    handleClickOrEnter(e) {
        var t, i;
        (this.worksOnlyForMobile && 600 < window.innerWidth) ||
            ((t = this.getAttribute("href")),
            (i = this.getAttribute("target")),
            "click" === e.type
                ? "_blank" === i
                    ? window.open(t, i)
                    : (window.location = t)
                : "mousedown" === e.type && (e.preventDefault(), 1 === e.button) && window.open(t, "_blank"));
    }
    handleMouseWheelClick(e) {
        var t;
        (this.worksOnlyForMobile && 600 < window.innerWidth) ||
            ((t = this.getAttribute("href")),
            "mousedown" === e.type && (e.preventDefault(), 1 === e.button) && window.open(t, "_blank"));
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
}
customElements.define("js-link", JsLink);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            (this._onModalCloseClick = this._onModalCloseClick.bind(this)),
            (this._onKeyUp = this._onKeyUp.bind(this)),
            (this._onKeyDown = this._onKeyDown.bind(this)),
            (this._onPointerUp = this._onPointerUp.bind(this)),
            (this._onClick = this._onClick.bind(this)),
            (this.getFocusableElements = this.getFocusableElements.bind(this));
    }
    connectedCallback() {
        this.moved || ((this.moved = !0), document.body.appendChild(this));
        var e = this.querySelector('[id^="ModalClose-"]');
        e && e.addEventListener("click", this._onModalCloseClick),
            this.addEventListener("keyup", this._onKeyUp),
            this.addEventListener("keydown", this._onKeyDown),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", this._onPointerUp)
                : this.addEventListener("click", this._onClick);
    }
    disconnectedCallback() {
        var e = this.querySelector('[id^="ModalClose-"]');
        e && e.removeEventListener("click", this._onModalCloseClick),
            this.removeEventListener("keyup", this._onKeyUp),
            this.removeEventListener("keydown", this._onKeyDown),
            this.classList.contains("media-modal")
                ? this.removeEventListener("pointerup", this._onPointerUp)
                : this.removeEventListener("click", this._onClick);
    }
    temporaryHideFocusVisible() {
        document.body.classList.add("no-focus-visible");
    }
    show(e) {
        (this.openedBy = e),
            (e = this.querySelector(".template-popup")),
            document.body.classList.add("overflow-hidden"),
            this.setAttribute("open", ""),
            e && e.loadContent(),
            (e = this.querySelector('[id^="ModalClose-"]')) &&
                (e.setAttribute("tabindex", "0"), e.focus(), this.temporaryHideFocusVisible()),
            (e = this.getFocusableElements().focusableElements).forEach((e) => e.setAttribute("tabindex", "0")),
            window.pauseAllMedia?.();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"),
            document.body.dispatchEvent(new CustomEvent("modalClosed")),
            this.removeAttribute("open"),
            this.openedBy &&
                "function" == typeof this.openedBy.focus &&
                (this.openedBy.focus(), this.temporaryHideFocusVisible()),
            (this.openedBy = null),
            this.getFocusableElements().focusableElements.forEach((e) => e.setAttribute("tabindex", "-1")),
            window.pauseAllMedia?.();
    }
    getFocusableElements() {
        var e = Array.from(this.querySelectorAll('button, [href], [role="button"], a, input, select, textarea')).filter(
            (e) => !e.hasAttribute("disabled") && !e.getAttribute("aria-hidden")
        );
        return { focusableElements: e, first: e[0], last: e[e.length - 1] };
    }
    _onModalCloseClick(e) {
        this.hide(!1);
    }
    _onKeyUp(e) {
        "ESCAPE" === e.code.toUpperCase() && this.hide();
    }
    _onKeyDown(e) {
        var t = "Tab" === e.key || 9 === e.keyCode || "Tab" === e.code,
            { first: i, last: n } = this.getFocusableElements();
        ("Escape" !== e.key && 27 !== e.keyCode && "Escape" !== e.code) || this.hide(),
            t &&
                (e.shiftKey
                    ? (document.activeElement !== i && document.activeElement !== this) ||
                      (e.preventDefault(), n.focus())
                    : document.activeElement === n && (e.preventDefault(), i.focus()));
    }
    _onPointerUp(e) {
        "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
    }
    _onClick(e) {
        e.target === this && this.hide();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        let e = this.querySelector("button");
        e &&
            e.addEventListener("click", () => {
                var t = document.querySelector(this.getAttribute("data-modal"));
                t && t.show(e);
            });
    }
}
customElements.define("modal-opener", ModalOpener);
class CartNotification extends HTMLElement {
    constructor() {
        super(),
            (this.notification = document.getElementById("cart-notification")),
            (this.header = document.querySelector("sticky-header")),
            (this.onBodyClick = this.handleBodyClick.bind(this)),
            this.notification.addEventListener("keyup", (e) => "Escape" === e.code && this.close()),
            this.querySelectorAll('button[type="button"]').forEach((e) =>
                e.addEventListener("click", this.close.bind(this))
            );
    }
    open() {
        this.notification.classList.add("animate", "active"),
            this.notification.addEventListener(
                "transitionend",
                () => {
                    this.notification.focus(), trapFocus(this.notification);
                },
                { once: !0 }
            ),
            document.body.addEventListener("click", this.onBodyClick);
    }
    close() {
        this.notification.classList.remove("active"),
            document.body.removeEventListener("click", this.onBodyClick),
            removeTrapFocus(this.activeElement);
    }
    renderContents(e) {
        (this.cartItemKey = e.key),
            this.getSectionsToRender().forEach((t) => {
                document.getElementById(t.id).innerHTML = this.getSectionInnerHTML(e.sections[t.id], t.selector);
            }),
            this.header && this.header.reveal(),
            this.open();
    }
    getSectionsToRender() {
        return [
            { id: "cart-notification-product", selector: `[id="cart-notification-product-${this.cartItemKey}"]` },
            { id: "cart-notification-button" },
            { id: "cart-icon-bubble" },
        ];
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    handleBodyClick(e) {
        (e = e.target) === this.notification ||
            e.closest("cart-notification") ||
            ((e = e.closest("details-disclosure, header-menu")),
            (this.activeElement = e ? e.querySelector("summary") : null),
            this.close());
    }
    setActiveElement(e) {
        this.activeElement = e;
    }
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/" + e } };
}
customElements.define("cart-notification", CartNotification),
    document.body.addEventListener("keydown", function (e) {
        var t = e.target,
            i = "thumbnail" === t.getAttribute("role"),
            n = "Enter" === e.code || "Enter" === e.key || 13 === e.keyCode,
            s = "Tab" === e.code || "Tab" === e.key || 9 === e.keyCode,
            o = "Space" === e.code || " " === e.key || 32 === e.keyCode,
            r = t.dataset.search;
        if (
            (s =
                (s =
                    (s && document.body.classList.remove("no-focus-visible"),
                    "button" === t.getAttribute("role") ||
                        "option" === t.getAttribute("role") ||
                        "A" === t.tagName ||
                        ("INPUT" === t.tagName && ["radio", "checkbox"].includes(t.type)) ||
                        "LABEL" === t.tagName ||
                        "JS-LINK" === t.tagName ||
                        i)) &&
                (n || o)) &&
            !i
        )
            n && (r || e.preventDefault(), e.stopPropagation()), o && !r && e.preventDefault(), t.click();
        else if (s && i) {
            let a;
            o = (n = document.querySelector("[data-gallery]")).querySelectorAll("li");
            let l = e.target.dataset.slideMediaId;
            o.forEach((e, t) => {
                e.dataset.mediaId === l && (a = t);
            }),
                n
                    ? (r = n.swiper)
                        ? (r.slideTo(a),
                          r.slideReset(),
                          (s = (t = o[a])?.querySelector("button")),
                          (i = t?.querySelector("video")),
                          (e = t?.querySelector("a")),
                          s?.focus(),
                          i?.focus(),
                          e?.click())
                        : console.error("Swiper instance not found on the element")
                    : console.error("Swiper element not found");
        }
    });
